import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  a.header_link {
    position: relative;
    background: hsla(0, 0%, 100%, 0.1);
    padding: 6px 10px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    width: fit-content;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    margin: 0 5px 0 0;
  }
  a.header_link:hover {
    background: hsla(0, 0%, 100%, 0.2);
  }
`

const developerCSS = css`
  a.header_link {
    text-decoration: none;
  }
  a.header_link:hover {
    color: #fff;
  }
`

export const AchievementButtonCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
